import { FC, useState, useEffect } from "react";

import Table from "@components/Table/gradeTable";
import Modal from "@components/Modal";
import { IModal, IVersion } from "@types";
import {
  ErrorServices,
  useFetchCashAllowanceVersionsQuery,
  useUpdateCashAllowanceVersionMutation,
} from "@services";
import { getVersionsColumns } from "../config";
import { useTypedSelector } from "@hooks";

interface ICashAllowanceVersions extends IModal {
  download: (id?: number | undefined) => void;
}

const CashAllowanceVersions: FC<ICashAllowanceVersions> = ({
  isVisible,
  setIsVisible,
  download,
}) => {
  const { company } = useTypedSelector(state => state.auth?.user!);
  const { id: company_id } = company!;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { data: versions, isLoading } = useFetchCashAllowanceVersionsQuery({
    page,
    page_size: pageSize,
    company_id,
  });
  const [updateCashAllowanceVersion] = useUpdateCashAllowanceVersionMutation();
  const { data, pagination } = versions || {};
  const [versionId, setVersionId] = useState<number | null>(null);

  useEffect(() => {
    if (data?.length) {
      const versionData = data?.find(
        (version: IVersion) => version?.is_active === "TRUE"
      );
      if (versionData?.id) {
        setVersionId(versionData?.id);
      }
    }
  }, [data]);

  const handleActive = async (id: number) => {
    try {
      setVersionId(id);
      await updateCashAllowanceVersion({ id, company_id }).unwrap();
    } catch (error) {
      ErrorServices(error);
    }
  };

  const versionsColumns = getVersionsColumns({
    handleActive,
    versionId,
    download,
  });
  return (
    <Modal
      mode="versions"
      footer={null}
      title="Previous Versions of Cash Allowances"
      isVisible={isVisible}
      width={855}
      setIsVisible={setIsVisible}
    >
      <div className="py-12">
        <Table
          isLoading={isLoading}
          data={data}
          columns={versionsColumns}
          pagination={true}
          customStyles="mx-4"
          count={pagination?.count}
          onChangePage={setPage}
          onPageSizeChange={setPageSize}
          page={page}
        />
      </div>
    </Modal>
  );
};

export default CashAllowanceVersions;
